import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContactForm() {
  const { t } = useTranslation();
  return (
    <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
      <div className="row">
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">{t('contact.form.fields.name')}</label>
          <input
            type="text"
            className="cs_form_field"
            placeholder={t('contact.form.placeholders.name')}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">{t('contact.form.fields.email')}</label>
          <input
            type="email"
            className="cs_form_field"
            placeholder={t('contact.form.placeholders.email')}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">{t('contact.form.fields.subject')}</label>
          <input
            type="text"
            className="cs_form_field"
            placeholder={t('contact.form.placeholders.subject')}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">{t('contact.form.fields.message')}</label>
          <textarea
            cols={30}
            rows={10}
            className="cs_form_field"
            placeholder={t('contact.form.placeholders.message')}
            defaultValue={''}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <div className="cs_height_18" />
          <button className="cs_btn cs_style_1">
            <span>{t('contact.form.submit')}</span>
            <i>
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
              <img src="/images/icons/arrow_white.svg" alt="Icon" />
            </i>
          </button>
        </div>
      </div>
    </div>
  );
}
